import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const ROLE_PERMISSIONS = {
  READ: PERMISSIONS.USERS_READ,
  WRITE: PERMISSIONS.ROLES_WRITE,
};

export const ROLE_QUERY_KEYS = queryKeys.roles;
